import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { EmailControlComponent } from './email-control/email-control.component';
import { EmailFormControlComponent } from './email-form-control.component';



@NgModule({
  declarations: [
    EmailFormControlComponent,
    EmailControlComponent
  ],
  exports: [
    EmailFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule
  ]
})
export class EmailFormControlModule { }
